import React from 'react';
import PropTypes from 'prop-types';
import { YFormField } from '../../../ui/YFormField';
import { YInput } from '../../../ui/YInput';
import { YSelect } from '../../../ui/YSelect';

const WEEKDAY_LABELS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

const REPEAT_OPTIONS = [
  { value: 'none', label: 'Does not repeat' },
  { value: 'daily', label: 'Daily' },
  { value: 'weekly', label: 'Weekly' },
  { value: 'monthly', label: 'Monthly' },
];

/** Recurrence block for club event dialog (schema slot: recurrence). */
export function ClubEventRecurrenceFields({
  freq,
  interval,
  until,
  byWeekday,
  onFreqChange,
  onIntervalChange,
  onUntilChange,
  onToggleWeekday,
}) {
  return (
    <div className="y-dialog__recurrence">
      <YFormField label="Repeat" htmlFor="club-event-repeat" labelClassName="y-label--dialog">
        <div className="y-dialog__repeat-row">
          <YSelect
            id="club-event-repeat"
            value={freq}
            onChange={(e) => onFreqChange(e.target.value)}
            aria-label="Recurrence frequency"
          >
            {REPEAT_OPTIONS.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </YSelect>
          {freq !== 'none' && (
            <>
              <YInput
                type="number"
                className="y-dialog__interval-input"
                min={1}
                max={365}
                value={interval}
                onChange={(e) => onIntervalChange(e.target.value)}
                aria-label="Recurrence interval"
              />
              <span className="text-muted small">interval</span>
            </>
          )}
        </div>
      </YFormField>
      {freq === 'weekly' && (
        <div className="y-dialog__weekdays">
          {WEEKDAY_LABELS.map((lbl, idx) => (
            <button
              key={lbl}
              type="button"
              className={['y-dialog__weekday', byWeekday.includes(idx) ? 'is-selected' : '']
                .filter(Boolean)
                .join(' ')}
              onClick={() => onToggleWeekday(idx)}
              aria-pressed={byWeekday.includes(idx)}
            >
              {lbl}
            </button>
          ))}
        </div>
      )}
      {freq !== 'none' && (
        <YFormField
          label="Ends on (optional)"
          htmlFor="club-event-repeat-until"
          labelClassName="y-label--dialog"
        >
          <YInput
            id="club-event-repeat-until"
            type="date"
            value={until}
            onChange={(e) => onUntilChange(e.target.value)}
          />
        </YFormField>
      )}
    </div>
  );
}

ClubEventRecurrenceFields.propTypes = {
  freq: PropTypes.string.isRequired,
  interval: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  until: PropTypes.string.isRequired,
  byWeekday: PropTypes.arrayOf(PropTypes.number).isRequired,
  onFreqChange: PropTypes.func.isRequired,
  onIntervalChange: PropTypes.func.isRequired,
  onUntilChange: PropTypes.func.isRequired,
  onToggleWeekday: PropTypes.func.isRequired,
};
